import { request } from '@umijs/max';
import { streamRequest } from './api';
import { BASE_URL } from './config';

/** 获取历史会话 GET /robot/chatbot/conversations */
export function getConversations(data: API.CHAT.ConversationsPramas) {
  return request<API.CHAT.ConversationsResponse>(
    '/robot/chatbot/conversations',
    {
      method: 'GET',
      params: data,
    },
  );
}

/** 获取聊天记录 GET /robot/chatbot/messages */
export function getMessages(data: API.CHAT.MessagesPramas) {
  return request<API.CHAT.MessagesResponse>('/robot/chatbot/messages', {
    method: 'GET',
    params: data,
  });
}

/** 获取聊天配置 GET /robot/chatbot/parameters */
export function getChatConfig() {
  return request<API.CHAT.ChatConfig>('/robot/chatbot/parameters', {
    method: 'GET',
  });
}

/** 发送消息（流式）- /robot/chatbot/chat-messages */
export const CHAT_SERVICE = '/robot/chatbot/chat-messages';
export async function sendMessageStream(data: Partial<API.CHAT.ChatMessage>) {
  const response = await streamRequest(CHAT_SERVICE, data);
  if (!response.ok) {
    throw new Error(`请求失败: ${response.status} ${response.statusText}`);
  }
  if (!response.body) {
    throw new Error('响应没有 body');
  }
  return response.body;
}

/** 语音合成（流式）- /robot/tts/stream */
export async function getTTSStream(text: string) {
  const response = await streamRequest('/robot/tts/stream', {
    text,
  });
  if (!response.ok) {
    throw new Error(`请求失败: ${response.status} ${response.statusText}`);
  }
  if (!response.body) {
    throw new Error('响应没有 body');
  }
  return response.body;
}
